import { render, staticRenderFns } from "./SingleBlog.vue?vue&type=template&id=358551ce&"
import script from "./SingleBlog.vue?vue&type=script&lang=js&"
export * from "./SingleBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports